export const authFetch = async (url, options = {}, onUnauthorized = () => {}) => {
    const headers = {
        ...(options.headers || {}),
    };

    // Set Content-Type if sending a body and not already set
    if (options.body && !headers['Content-Type'] && (!options.method || options.method.toUpperCase() !== 'GET')) {
        headers['Content-Type'] = 'application/json';
    }

    try {
        const response = await fetch(url, {
            credentials: "include",
            ...options,
            headers,
        });

        if (response.status === 401) {
            onUnauthorized();
            return null;
        }

        if (response.status === 204) {
            // No Content, treat as success
            return null;
        }

        if (!response.ok) {
            const error = new Error(response.statusText);
            error.status = response.status;
            throw error;
        }

        return await response.json();
    } catch (error) {
        console.error("Error en authFetch:", error);
        throw error;
    }
};
